import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

export type BadgeVariant = 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'blue' | 'orange' | 'gray';
export type BadgeAppearance = 'solid' | 'subtle';

@Component({
  selector: 'ui-badge',
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.css',
  standalone: true,
  imports: [NgClass, MatTooltipModule],
})
export class BadgeComponent {
  readonly variant = input<BadgeVariant>('primary');
  readonly size = input<'sm' | 'md'>('md');
  readonly appearance = input<BadgeAppearance>('solid');
  readonly value = input<string>('');
  readonly tooltip = input<string>('');
  readonly preventNumericDisplay = input<boolean>(false);
  readonly justifySelf = input<'start' | 'center' | 'end' | 'stretch'>('center');

  // Determine if the value is numeric
  // If it is, we have different sizing and padding
  readonly isValueNumeric = computed(() => {
    return !this.preventNumericDisplay() && !isNaN(Number(this.value()));
  });

  // If the value is numeric, display it with a + if it's greater than 9
  readonly numericDisplayValue = computed(() => {
    const value = Number(this.value());
    return value >= 10 ? '9+' : value.toString();
  });

  readonly classes = computed(() => {
    return {
      'ui-badge': true,
      'ui-badge-number': this.isValueNumeric(),
      [`justify-self-${this.justifySelf()}`]: true,
      [`ui-badge-${this.size()}`]: true,
      [`ui-badge-${this.appearance()}`]: true,
      [`ui-badge-${this.variant()}`]: true,
    };
  });
}
